import styled from '@emotion/styled'
import { defaultSpacing, mediumSpacing } from '../enums/Spacings'
import Box from './Box'

export const PageContainer = styled(Box)`
  padding: ${defaultSpacing} ${mediumSpacing};
`
